module.exports = __webpack_public_path__ + "static/media/teamIcon2.80b4337d.svg";